module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "preface-title"
  }), _vm._v(" "), _c('p', [_vm._v("“The Pentagon’s secret study of the Vietnam war discloses that President Kennedy knew and approved of plans for the military coup d’état that overthrew President Ngo Dinh Diem in 1963. . . .")]), _vm._v(" "), _c('p', [_vm._v("“ ‘Our complicity in his overthrow heightened our responsibilities and our commitments’ in Vietnam, the study finds. …”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("THE PENTAGON PAPERS")]), _vm._v(", as published by"), _c('br'), _c('em', [_vm._v("The New York Times")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f6958c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface001.vue
// module id = 72
// module chunks = 0